<template>
  <v-dialog v-model="dialog" persistent width="700">
    <v-card>
      <!-- Cabecera del formulario -->
      <!-- {{ this.$data.form }} -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{
            form.id ? "Editar Formacion Academica" : "Crear Formacion Academica"
          }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md6>
                <v-autocomplete
                  v-model="form.id_parametro_estudio"
                  :items="estudios"
                  item-text="valor"
                  :item-value="val => parseInt(val.id)"
                  label="Estudios:"
                  :rules="$validate(['required'])"
                ></v-autocomplete>
              </v-flex>
              <v-flex md6>
                <v-autocomplete
                  v-model="form.id_institucion"
                  :items="instituciones"
                  item-text="nombre_institucion"
                  :item-value="val => parseInt(val.id)"
                  label="Nombre institución:"
                  :rules="$validate(['required'])"
                ></v-autocomplete>
              </v-flex>
              <v-flex md4>
                <v-autocomplete
                  v-model="form.id_carrera"
                  :items="carreras"
                  item-text="nombre_carrera"
                  :item-value="val => parseInt(val.id)"
                  label="Carrera o área de formación"
                  :rules="$validate(['required'])"
                ></v-autocomplete>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  label="Fecha de inicio"
                  v-model="form.fecha_inicio"
                  type="date"
                ></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  label="Fecha de conclusión"
                  v-model="form.fecha_conclusion"
                  :rules="$validate(['required'])"
                  required
                  type="date"
                ></v-text-field>
              </v-flex>

              <v-flex md3>
                <v-radio-group
                  label="¿Tiene título?"
                  v-model="form.titulado"
                  :rules="[
                    v => {
                      if (v == null) {
                        return 'El campo es obligatorio.';
                      }
                      return true;
                    }
                  ]"
                >
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"> </v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>


<!-- DISTINTOS A LICENCIATURA -->
          <v-container
            grid-list-md
            v-if="this.form.titulado && this.form.id_parametro_estudio != 79"
          >
            <v-layout wrap>
              <v-flex md9>
                <v-text-field
                  v-if="this.form.titulado != false"
                  label="Título obtenido"
                  v-model="form.titulo_obtenido"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                ></v-text-field>
              </v-flex>

              <v-flex md9>
                <v-autocomplete
                  v-model="form.id_profesion"
                  :items="profesiones"
                  item-text="nombre_profesion"
                  :item-value="val => parseInt(val.id)"
                  label="Profesión"
                  :rules="$validate(['id_parametro_estudio'])"
                ></v-autocomplete>
              </v-flex>

              <v-flex md12> Título académico (TA)</v-flex>
              <v-flex md6>
                <v-radio-group v-model="form.id_parametro_ta" row>
                  <v-flex xs6>
                    <v-radio label="Si" :value="31"></v-radio>
                  </v-flex>
                  <v-flex xs6>
                    <v-radio label="No" :value="32"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-if="this.form.id_parametro_ta ==31 || this.form.id_parametro_ta == null"
                  label="Fecha"
                  v-model="form.fecha_ta"
                  type="date"
                ></v-text-field>
              </v-flex>
              <v-flex md2>
                
                <v-text-field
                  v-if="this.form.id_parametro_ta ==31 || this.form.id_parametro_ta == null"
                  type="number"
                  label="Número"
                  v-model.number="form.numero_ta"
                  maxlength="10"
                  :rules="[
                    v => {
                      if (v > 2147483647) return 'Valor invalido';

                      if (v < 0) return 'El campo no puede ser negativo.';
                      return true;
                    }
                  ]"
                ></v-text-field>
              </v-flex>

              <v-flex md12> Título en provisión nacional (TPN) </v-flex>
              <v-flex md6>
                <v-radio-group v-model="form.id_parametro_tpn" row>
                  <v-flex xs6>
                    <v-radio label="Si" :value="34"></v-radio>
                  </v-flex>
                  <v-flex xs6>
                    <v-radio label="No" :value="35"></v-radio>
                  </v-flex>

                </v-radio-group>
              </v-flex>

              <v-flex md4>
                <v-text-field
                  v-if="this.form.id_parametro_tpn ==34 || this.form.id_parametro_tpn == null"
                  label="Fecha"
                  v-model="form.fecha_tpn"  
                  type="date"
                ></v-text-field>
              </v-flex>
              <v-flex md2>
                <v-text-field
                  v-if="this.form.id_parametro_tpn ==34 || this.form.id_parametro_tpn == null"
                  type="number"
                  label="Número"
                  v-model.number="form.numero_tpn"
                  :rules="[
                    v => {
                      if (v > 2147483647) return 'Valor invalido';

                      if (v < 0) return 'El campo no puede ser negativo.';
                      return true;
                    }
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex md12>
                <v-flex>
                  <input
                    id="input"
                    type="file"
                    @change="handleFileUpload()"
                    ref="file"
                    accept="image/*, application/pdf"
                    value="reset"
                  />
                  <p class="red--text body-1" v-if="error">
                    {{ mensjageerror }}
                  </p>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>


<!-- PARA LICENCIATURA -->
          <v-container
            grid-list-md
            v-if="this.form.titulado && this.form.id_parametro_estudio == 79"
          >
            <v-layout wrap>
              <v-flex md9>
                <v-text-field
                  label="Título obtenido"
                  v-model="form.titulo_obtenido"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                ></v-text-field>
              </v-flex>

              <v-flex md9>
                <v-autocomplete
                  v-model="form.id_profesion"
                  :items="profesiones"
                  item-text="nombre_profesion"
                  :item-value="val => parseInt(val.id)"
                  label="Profesión"
                  :rules="$validate(['required'])"
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex md12> Título académico (TA)</v-flex>
              <v-flex md6>
                <v-radio-group
                  v-model="form.id_parametro_ta"
                  row
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex xs6>
                    <v-radio label="Si" :value="31"></v-radio>
                  </v-flex>
                  <v-flex xs6>
                    <v-radio label="No" :value="32"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
              <v-flex md4>
                <v-text-field
                v-if="this.form.id_parametro_ta ==31 || this.form.id_parametro_ta == null"
                  label="Fecha"
                  v-model="form.fecha_ta"
                  :rules="$validate(['required'])"
                  required
                  type="date"
                ></v-text-field>
              </v-flex>
              <v-flex md2>
                <v-text-field
                  
                  v-if="this.form.id_parametro_ta ==31 || this.form.id_parametro_ta == null"
                  type="number"
                  label="Número"
                  v-model.number="form.numero_ta"
                  maxlength="10"
                  required
                  :rules="[
                    v => {
                      if (v > 2147483647) return 'Valor invalido';
                      if (v == null) return 'El campo es obligatorio.';
                      if (v < 0) return 'El campo no puede ser negativo.';
                      return true;
                    }
                  ]"
                ></v-text-field>
              </v-flex>

              <v-flex md12> Título en provisión nacional (TPN) </v-flex>
              <v-flex md6>
                <v-radio-group v-model="form.id_parametro_tpn" row>
                  <v-flex xs6>
                    <v-radio label="Si" :value="34"></v-radio>
                  </v-flex>
                  <v-flex xs6>
                    <v-radio label="No" :value="35"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>

              <v-flex md4>
                <v-text-field
                  v-if="this.form.id_parametro_tpn ==34 || this.form.id_parametro_tpn == null"
                  label="Fecha"
                  v-model="form.fecha_tpn"
                  type="date"
                ></v-text-field>
              </v-flex>
              <v-flex md2>
                <v-text-field
                  v-if="this.form.id_parametro_tpn ==34 || this.form.id_parametro_tpn == null"
                  type="number"
                  label="Número"
                  v-model.number="form.numero_tpn"
                  :rules="[
                    v => {
                      if (v > 2147483647) return 'Valor invalido';

                      if (v < 0) return 'El campo no puede ser negativo.';
                      return true;
                    }
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex md12>
                <v-flex>
                  <input
                    id="input"
                    type="file"
                    @change="handleFileUpload()"
                    ref="file"
                    accept="image/*, application/pdf"
                    value="reset"
                  />
                  <p class="red--text body-1" v-if="error">
                    {{ mensjageerror }}
                  </p>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
          
          <!-- <v-btn
                color="info"
                v-if="this.form != null"
                @click.native="limpiarRegistro()"
                slot="activator"
              >
                <v-icon dark>book</v-icon> Limpiar
              </v-btn> -->
                
          
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      instituciones: [],
      profesiones: [],
      carreras: [],
      ano_universidad: [],
      personas: [],
      tpns: [],
      tas: [],
      estudios: [],
      documento_requisito: {},
      error: false,
      cargado: false,
      mensjageerror: ""
    };
  },
  mounted() {
    this.obtenerEstudios();
    this.obtenerTas();
    this.obtenerTpns();
    this.obtenerPersonas();
    this.obtenerAnoUniversitario();
    this.obtenerCarreras();
    this.obtenerInstituciones();
    this.obtenerProfesiones();
    this.$bus.$on("openDialogCrearActualizarFormacionAcademica", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {

    limpiarRegistro(){
            this.form.id_parametro_estudio = null;
            this.form.id_institucion = null;
            this.form.id_carrera = null;
            this.form.fecha_inicio= null;
            this.form.fecha_conclusion = null;
            this.form.titulado = null;
            this.form.titulo_obtenido = null;
            this.form.id_profesion = null;
            this.form.id_parametro_ta = null;
            this.form.fecha_ta = null;
            this.form.numero_ta = null;
            this.form.id_parametro_tpn = null;
            this.form.fecha_tpn = null;
            this.form.numero_tpn = null;
            this.form.url_documento = null;
    },
    close() {
      (this.form = {}), (this.loading = false);
      this.file = null;
      this.valid = false;
      this.cargado = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
      // this.$refs.file.value = "";
    },

    async save() {
      if (this.error) {
        return this.error;
      }

      if (this.$refs.form.validate()) {
        if (!this.form.titulado) {
            this.form.titulo_obtenido = null;
            this.form.id_profesion = null;
            this.form.id_parametro_ta = null;
            this.form.fecha_ta = null;
            this.form.numero_ta = null;
            this.form.id_parametro_tpn = null;
            this.form.fecha_tpn = null;
            this.form.numero_tpn = null;
            this.form.url_documento = null;
        }else {
          if (this.form.id_parametro_ta == 32) {
            this.form.fecha_ta = null;
            this.form.numero_ta = null;
          }
          if (this.form.id_parametro_tpn == 35) {
            this.form.fecha_tpn = null;
            this.form.numero_tpn = null;
          }
        } 

        this.loading = true;
        try {
          if (this.cargado) {
            if (this.form.titulado) {
              let formData = new FormData();
              formData.append("file", this.file);
              let res = await this.$http.post(
                process.env.API_URL + "public/upload",
                formData
              );
              this.form.url_documento = res.data;
            } else {
              this.form.url_documento = null;
            }
          }
          if (this.form.id) {
            const id = this.form.id;
            delete this.form.id;
            delete this.form._user_created;
            delete this.form.institucion;
            delete this.form.carrera;
            delete this.form.profesion;
            delete this.form.parametro_ta;
            delete this.form.parametro_tpn;
            delete this.form._user_updated;
            delete this.form._created_at;
            delete this.form._updated_at;
            delete this.form.parametro_estudio;
            await this.$service.graphql({
              query: `
								mutation edit($id: ID!, $formacion_academica: EditFormacionAcademica!){
									formacionAcademicaEdit(id: $id, formacion_academica: $formacion_academica){
										id
									}
								}
							`,
              variables: {
                id: id,
                formacion_academica: this.form
              }
            });
          } else {
            if (this.form.titulado) {
              if (!this.cargado) {
                this.error = true;
                this.mensjageerror = "Debe seleccionar un archivo.";
                this.loading = false;
                return false;
              } else {
                this.error = false;
                this.mensjageerror = "";
              }
            }
            let user = this.$storage.get("user");
            if (this.$route.params.id) {
              this.form.id_persona = parseInt(this.$route.params.id);
            } else {
              this.form.id_persona = user.id_persona;
            }
            delete this.form.parametro_estudio;
            this.form.id_estado = 1;
            await this.$service.graphql({
              query: `
								mutation add($formacion_academica: NewFormacionAcademica!){
									formacionAcademicaAdd(formacion_academica: $formacion_academica){
										id
									}
								}
							`,
              variables: {
                formacion_academica: this.form
              }
            });
          }
        } catch (error) {
          console.log(error);
        }
        if (this.form.titulado) {
          document.getElementById("input").value = "";
        }
        this.$message.success();
        this.loading = false;
        this.close();
      }
    },


    async obtenerInstituciones() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              institucions{
                rows{
                  id
                  nombre_institucion
                }
              }
          }`
        });
        this.instituciones = respuesta.institucions.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerProfesiones() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              profesiones{
                rows{
                  id
                  nombre_profesion
                }
              }
            }
          `
        });
        this.profesiones = respuesta.profesiones.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerCarreras() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
         query{
           carreras{
             rows{
               id
					nombre_carrera
				}
			}
		}
        `
        });
        this.carreras = respuesta.carreras.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerAnoUniversitario() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
          query{
            params(tipo:"ano_universitario"){
              rows{
                id
                valor
              }
            }
          }
        `
        });
        this.ano_universidad = respuesta.params.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerPersonas() {
      try {
        let res = await this.$service.graphql({
          query: `
						query{
							personas{
								rows{
									id
									nombres
									ap_paterno
									ap_materno
								}
							}
						}
					`
        });
        this.personas = res.personas.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerTpns() {
      try {
        let res = await this.$service.graphql({
          query: `
						 query{
            params(tipo:"tpn"){
              rows{
                id
                valor
              }
            }
          }
					`
        });
        this.tpns = res.params.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerTas() {
      try {
        let res = await this.$service.graphql({
          query: `
						 query{
            params(tipo:"ta"){
              rows{
                id
                valor
              }
            }
          }
					`
        });
        this.tas = res.params.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async obtenerEstudios() {
      try {
        let res = await this.$service.graphql({
          query: `
						 query{
            params(tipo:"estudio"){
              rows{
                id
                valor
              }
            }
          }
					`
        });
        this.estudios = res.params.rows;
      } catch (err) {
        console.log(err);
      }
    },
   handleFileUpload() {
      if (this.$refs.file.value !== "") {
        this.cargado = true;
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].size > 2048999) {
          this.error = true;
          this.mensjageerror = "El archivo excede el tamaño permitido de 2MB.";
        } 
        else if (this.$refs.file.value === "") {
          this.error = true;
          this.mensjageerror = "Archivo invalido.";
        } else if (!(
          this.$refs.file.files[0].type.includes("application/pdf") ||
          this.$refs.file.files[0].type.includes("image/"))) {
          this.error = true;
          this.mensjageerror = "Formato no admitido por el sistema";
        } 
        else {
          this.error = false;
          this.mensjageerror = "";
        }
        this.file = file;
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/dialogs/CrearActualizarFormacionAcademica.vue